import Box from "@mui/material/Box";
import type {SxProps, Theme} from "@mui/material/styles";
import {SIDEBAR_WIDTH} from "crqlar-react-common/dist/utils/useDimensions";
import type {ReactNode} from "react";

const DEFAULT_PANEL_WIDTH = 320;

interface RightSidebarFloatingPanelProps {
    children: ReactNode;
    width?: number;
    sx?: SxProps<Theme>;
}

export function RightSidebarFloatingPanel({
    children,
    width = DEFAULT_PANEL_WIDTH,
    sx,
}: RightSidebarFloatingPanelProps) {
    return (
        <Box
            sx={[
                {
                    position: {xs: "fixed", md: "absolute"},
                    top: 0,
                    bottom: 0,
                    right: {xs: 0, md: SIDEBAR_WIDTH},
                    width: {xs: `min(${width}px, calc(100vw - 8px))`, md: width},
                    height: "100%",
                    overflowY: "auto",
                    overflowX: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "background.paper",
                    borderLeft: "1px solid rgba(15, 23, 42, 0.12)",
                    boxShadow: "-8px 0 28px rgba(15, 23, 42, 0.08)",
                    zIndex: {xs: 1200, md: 40},
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {children}
        </Box>
    );
}
